const isObject = (value) => {
  return !!(value && typeof value === 'object' && !Array.isArray(value));
};

export default function (contentObj = {}, chain = ''): boolean {
  const chainKeys = chain.split('.');
  let index = 0;

  const isValid = (value) => {
    let result = false;

    (function findValue(value) {
      const searchedValue = value[chainKeys[index]];

      if (isObject(searchedValue)) {
        index++;
        findValue(searchedValue);
      } else if (typeof searchedValue === 'string' || typeof searchedValue === 'number') {
        result = true;
      }
    })(value);

    return result;
  };

  return isValid(contentObj);
}
